"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _orgList = _interopRequireDefault(require("./graphql/orgList.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
var _questorganizationTable = _interopRequireDefault(require("./graphql/questorganizationTable.graphql"));
var _dataCollectionTable = _interopRequireDefault(require("./graphql/dataCollectionTable.graphql"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Fortress = window.cccisd.fortress;
var isSuperUser = Fortress === null || Fortress === void 0 ? void 0 : Fortress.isSuperUser();
var Usage = function Usage(props) {
  var _Fortress$settings, _Fortress$settings$pe;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentOrg = _useState2[0],
    setCurrentOrg = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    orgList = _useState4[0],
    setOrgList = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var hasAnyQuestAdmin = Fortress === null || Fortress === void 0 ? void 0 : (_Fortress$settings = Fortress.settings) === null || _Fortress$settings === void 0 ? void 0 : (_Fortress$settings$pe = _Fortress$settings.permissions) === null || _Fortress$settings$pe === void 0 ? void 0 : _Fortress$settings$pe.find(function (item) {
    return item.includes('quest.admin');
  });
  (0, _react.useEffect)(function () {
    if (isSuperUser || hasAnyQuestAdmin) {
      getOrgList();
    } else {
      setLoading(false);
    }
  }, []);
  var getOrgList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var response, organizations, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return _cccisdApollo.client.query({
              query: _orgList["default"],
              fetchPolicy: 'network-only'
            });
          case 1:
            response = _context.v;
            if (response && response.data) {
              organizations = response.data.groups.questorganizationList.map(function (org) {
                return {
                  label: org.group.label,
                  value: org.group.groupId
                };
              });
              setOrgList(organizations);
              setCurrentOrg(organizations[0]);
              setLoading(false);
            }
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error(_t);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function getOrgList() {
      return _ref.apply(this, arguments);
    };
  }();
  var renderOrgSelect = function renderOrgSelect() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].wrapper
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, "Quest Organization"), /*#__PURE__*/_react["default"].createElement("select", {
      className: "form-select",
      onChange: handleSelectChange
    }, orgList.map(function (org, i) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: i,
        value: org.value
      }, org.label);
    }))));
  };
  var handleSelectChange = function handleSelectChange(event) {
    setLoading(true);
    var match = orgList.find(function (org) {
      return org.value === +event.target.value;
    });
    setCurrentOrg(match);
    setLoading(false);
  };
  var renderOrgTable = function renderOrgTable(_ref2) {
    var _Fortress$user$acting;
    var loadData = _ref2.loadData,
      renderDefault = _ref2.renderDefault;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].headerBlock
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      style: {
        display: 'inline-block'
      }
    }, "Usage", ' ', isSuperUser || !((_Fortress$user$acting = Fortress.user.acting.group) !== null && _Fortress$user$acting !== void 0 && _Fortress$user$acting.label) || !currentOrg ? '' : " - ".concat(Fortress.user.acting.group.label))), renderDefault());
  };
  var renderDataCollectionTable = function renderDataCollectionTable(_ref3) {
    var _Fortress$user$acting2;
    var loadData = _ref3.loadData,
      renderDefault = _ref3.renderDefault;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].headerBlock
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      style: {
        display: 'inline-block'
      }
    }, "Data Collection Waves", ' ', isSuperUser || !((_Fortress$user$acting2 = Fortress.user.acting.group) !== null && _Fortress$user$acting2 !== void 0 && _Fortress$user$acting2.label) || !currentOrg ? '' : " - ".concat(Fortress.user.acting.group.label))), renderDefault());
  };
  var orgTableColumns = [{
    name: 'group.label',
    label: 'Quest Organization',
    filter: true,
    sort: true
  }, {
    name: 'childGroups.questprojectCount',
    label: '# of Projects',
    className: 'text-center',
    filter: true,
    sort: true
  }, {
    name: 'responseCount',
    label: '# of Responses',
    className: 'text-center',
    render: function render(_ref4) {
      var value = _ref4.value,
        row = _ref4.row,
        loadData = _ref4.loadData,
        customData = _ref4.customData;
      var responseCount = 0;
      var projectList = row['childGroups.questprojectList'];
      projectList.forEach(function (proj) {
        responseCount += proj.responseCount;
      });
      return responseCount;
    }
  }, {
    name: 'respondentCount',
    label: '# of Respondents',
    className: 'text-center',
    render: function render(_ref5) {
      var value = _ref5.value,
        row = _ref5.row,
        loadData = _ref5.loadData,
        customData = _ref5.customData;
      var respondentCount = 0;
      var projectList = row['childGroups.questprojectList'];
      projectList.forEach(function (proj) {
        proj.assignmentList.forEach(function (assignment) {
          assignment.deploymentList.forEach(function (deployment) {
            respondentCount += deployment.respondentCount;
          });
        });
      });
      if (row['fields.respondentLimit']) {
        if (respondentCount > +row['fields.respondentLimit']) {
          return /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              backgroundColor: '#F08B89'
            }
          }, "".concat(respondentCount, " / ").concat(row['fields.respondentLimit']));
        }
        return "".concat(respondentCount, " / ").concat(row['fields.respondentLimit']);
      }
      return respondentCount;
    }
  }, {
    name: 'surveyCount',
    label: '# of Surveys',
    className: 'text-center',
    render: function render(_ref6) {
      var value = _ref6.value,
        row = _ref6.row,
        loadData = _ref6.loadData,
        customData = _ref6.customData;
      var surveyCount = 0;
      var projectList = row['childGroups.questprojectList'];
      projectList.forEach(function (proj) {
        surveyCount += proj.assignmentSummary.surveyCount;
      });
      return surveyCount;
    }
  }, {
    name: 'surveyItems',
    label: '# of Survey Items',
    className: 'text-center',
    render: function render(_ref7) {
      var value = _ref7.value,
        row = _ref7.row,
        loadData = _ref7.loadData,
        customData = _ref7.customData;
      var itemCount = 0;
      var projectList = row['childGroups.questprojectList'];
      projectList.forEach(function (proj) {
        itemCount += proj.assignmentSummary.flowEntityCount;
      });
      return itemCount;
    }
  }, {
    name: 'emailsSent',
    label: '# of Emails Sent',
    className: 'text-center',
    render: function render(_ref8) {
      var value = _ref8.value,
        row = _ref8.row,
        loadData = _ref8.loadData,
        customData = _ref8.customData;
      var emailCount = 0;
      var projectList = row['childGroups.questprojectList'];
      projectList.forEach(function (proj) {
        emailCount += proj.sentEmailCount;
      });
      return emailCount;
    }
  }, {
    name: 'smsSent',
    label: '# of SMS Sent',
    className: 'text-center',
    render: function render(_ref9) {
      var value = _ref9.value,
        row = _ref9.row,
        loadData = _ref9.loadData,
        customData = _ref9.customData;
      var smsCount = 0;
      var projectList = row['childGroups.questprojectList'];
      var smsLimit = row['fields.smsLimit'];
      projectList.forEach(function (proj) {
        smsCount += proj.sentSmsCount;
      });
      if (smsLimit && +smsLimit !== 0) {
        if (smsCount > +smsLimit) {
          return /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              backgroundColor: '#F08B89'
            }
          }, "".concat(smsCount, " / ").concat(smsLimit));
        }
        return "".concat(smsCount, " / ").concat(smsLimit);
      }
      return smsCount;
    }
  }];
  var dataCollectionColumns = [{
    name: 'label',
    label: 'Data Collection Wave',
    filter: true,
    sort: true
  }, {
    name: 'assignment.group.group.label',
    label: 'Quest Project',
    filter: true,
    sort: true
  }, {
    name: 'assignment.label',
    label: 'Quest',
    filter: true,
    sort: true
  }, {
    name: 'assignmentProgressCount',
    label: '# of Responses',
    className: 'text-center',
    filter: true,
    sort: true
  }, {
    name: 'respondentCount',
    label: '# of Respondents',
    className: 'text-center',
    filter: true,
    sort: true
  }, {
    name: 'emailCount',
    label: '# of Emails Sent',
    className: 'text-center',
    filter: true,
    sort: true
  }, {
    name: 'smsCount',
    label: '# of SMS Sent',
    className: 'text-center',
    filter: true,
    sort: true
  }];
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, orgList.length > 0 && renderOrgSelect(), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    key: "orgs",
    columns: orgTableColumns,
    query: _questorganizationTable["default"],
    rowKey: "group.groupId",
    graphqlVariables: {
      groupId: +(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.value)
    },
    render: renderOrgTable
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '20px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: "Data Collection Waves"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    key: "dataCollection",
    columns: dataCollectionColumns,
    query: _dataCollectionTable["default"],
    rowKey: "deploymentId",
    graphqlVariables: {
      groupId: +(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.value)
    },
    render: renderDataCollectionTable
  })))));
};
var _default = exports["default"] = Usage;